import { buttons } from "@icarros/theme-react";
export const { sizes, types } = buttons;
export var ActionVariants;
(function (ActionVariants) {
    ActionVariants["neutral"] = "neutral";
    ActionVariants["primary"] = "primary";
    ActionVariants["secondary"] = "secondary";
})(ActionVariants || (ActionVariants = {}));
export var ActionWeights;
(function (ActionWeights) {
    ActionWeights["small"] = "small";
    ActionWeights["medium"] = "medium";
})(ActionWeights || (ActionWeights = {}));
export var ActionIconPositions;
(function (ActionIconPositions) {
    ActionIconPositions["start"] = "start";
    ActionIconPositions["end"] = "end";
})(ActionIconPositions || (ActionIconPositions = {}));
//# sourceMappingURL=constants.js.map